import { TertiaryPackingRptConstants } from '../constants';

export function TertiaryPackingRpt(state = {}, action) {
    switch (action.type) {
        case TertiaryPackingRptConstants.LOADING_REQUEST:
            return {
                ...state,
                loding: action.isbool
            };
        case TertiaryPackingRptConstants.GETALL_REQUEST:
            return {
                ...state,
                loading: true
            };
        case TertiaryPackingRptConstants.GETALL_SUCCESS:
            return {
                ...state,
                items: action.datas
            };
        case TertiaryPackingRptConstants.GETALL_FAILURE:
            return {
                ...state,
                error: action.error
            };
        case TertiaryPackingRptConstants.GETEXPORT_REQUEST:
            return {
                ...state,
                exporting: true
            };
        case TertiaryPackingRptConstants.GETEXPORT_SUCCESS:
            return {
                ...state,
                exportitems: action.datas
            };
        case TertiaryPackingRptConstants.GETEXPORT_FAILURE:
            return {
                ...state,
                error: action.error
            };
        default:
            return state
    }

}